import vsComponent from './vsProgress'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
